import * as React from 'react';

import { createIcon } from '../utils';

export const ExternalMonitorsIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => {
    const reactId = React.useId();
    const maskId = `external-transmissions-mask-${reactId}`;

    return (
      <svg
        ref={ref}
        className={className}
        width={width}
        height={height}
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <mask id={maskId} fill="white">
          <path
            d="M6.70386 9.5325C6.70386 6.97561 8.77663 4.90283 11.3335 4.90283H19.6668C22.2237 4.90283 24.2964 6.97561 24.2964 9.5325V17.8658C24.2964 20.4227 22.2237 22.4954 19.6668 22.4954H11.3335C8.77663 22.4954 6.70386 20.4227 6.70386 17.8658V9.5325Z"
            strokeWidth={2}
          />
        </mask>
        <path
          d="M11.3335 4.90283V6.30283H19.6668V4.90283V3.50283H11.3335V4.90283ZM24.2964 9.5325H22.8965V17.8658H24.2964H25.6964V9.5325H24.2964ZM19.6668 22.4954V21.0954H11.3335V22.4954V23.8954H19.6668V22.4954ZM6.70386 17.8658H8.10386V9.5325H6.70386H5.30386V17.8658H6.70386ZM11.3335 22.4954V21.0954C9.54983 21.0954 8.10386 19.6495 8.10386 17.8658H6.70386H5.30386C5.30386 21.1958 8.00343 23.8954 11.3335 23.8954V22.4954ZM24.2964 17.8658H22.8965C22.8965 19.6495 21.4505 21.0954 19.6668 21.0954V22.4954V23.8954C22.9969 23.8954 25.6964 21.1959 25.6964 17.8658H24.2964ZM19.6668 4.90283V6.30283C21.4505 6.30283 22.8965 7.7488 22.8965 9.5325H24.2964H25.6964C25.6964 6.20241 22.9969 3.50283 19.6668 3.50283V4.90283ZM11.3335 4.90283V3.50283C8.00343 3.50283 5.30386 6.20241 5.30386 9.5325H6.70386H8.10386C8.10386 7.7488 9.54983 6.30283 11.3335 6.30283V4.90283Z"
          fill="currentColor"
          strokeWidth={2}
          mask={`url(#${maskId})`}
        />
        <path
          d="M27.0741 14.1625V14.8625H28.926V14.1625V13.4625H27.0741V14.1625ZM29.8519 15.0884H29.1519V18.7921H29.8519H30.5519V15.0884H29.8519ZM28.926 19.718V19.018H27.0741V19.718V20.418H28.926V19.718ZM26.1482 18.7921H26.8482V15.0884H26.1482H25.4482V18.7921H26.1482ZM27.0741 19.718V19.018C26.9493 19.018 26.8482 18.9169 26.8482 18.7921H26.1482H25.4482C25.4482 19.6901 26.1761 20.418 27.0741 20.418V19.718ZM29.8519 18.7921H29.1519C29.1519 18.9169 29.0507 19.018 28.926 19.018V19.718V20.418C29.8239 20.418 30.5519 19.6901 30.5519 18.7921H29.8519ZM28.926 14.1625V14.8625C29.0507 14.8625 29.1519 14.9636 29.1519 15.0884H29.8519H30.5519C30.5519 14.1904 29.8239 13.4625 28.926 13.4625V14.1625ZM27.0741 14.1625V13.4625C26.1761 13.4625 25.4482 14.1904 25.4482 15.0884H26.1482H26.8482C26.8482 14.9636 26.9493 14.8625 27.0741 14.8625V14.1625Z"
          fill="currentColor"
          strokeWidth={2}
        />
        <path
          d="M2.07413 14.1625V14.8625H3.92596V14.1625V13.4625H2.07413V14.1625ZM4.8519 15.0884H4.1519V18.7921H4.8519H5.5519V15.0884H4.8519ZM3.92596 19.718V19.018H2.07413V19.718V20.418H3.92596V19.718ZM1.14819 18.7921H1.84819V15.0884H1.14819H0.448193V18.7921H1.14819ZM2.07413 19.718V19.018C1.94935 19.018 1.84819 18.9169 1.84819 18.7921H1.14819H0.448193C0.448193 19.6901 1.17615 20.418 2.07413 20.418V19.718ZM4.8519 18.7921H4.1519C4.1519 18.9169 4.05074 19.018 3.92596 19.018V19.718V20.418C4.82394 20.418 5.5519 19.6901 5.5519 18.7921H4.8519ZM3.92596 14.1625V14.8625C4.05074 14.8625 4.1519 14.9636 4.1519 15.0884H4.8519H5.5519C5.5519 14.1904 4.82394 13.4625 3.92596 13.4625V14.1625ZM2.07413 14.1625V13.4625C1.17615 13.4625 0.448193 14.1904 0.448193 15.0884H1.14819H1.84819C1.84819 14.9636 1.94935 14.8625 2.07413 14.8625V14.1625Z"
          fill="currentColor"
          strokeWidth={2}
        />
        <path
          d="M2.99976 19.9493V22.3992C2.99976 23.7309 4.07932 24.8105 5.41103 24.8105H12.3304C13.8935 24.8105 14.7081 22.9498 13.6479 21.8012"
          stroke="currentColor"
          strokeWidth={1.4}
        />
        <path
          d="M28.0002 19.9493V22.158C28.0002 23.6229 26.8127 24.8105 25.3478 24.8105H18.3709C16.8199 24.8105 15.9435 23.0306 16.8891 21.8012"
          stroke="currentColor"
          strokeWidth={1.4}
        />
        <path
          d="M23.18 14.1391H19.3528L17.0565 17.5836L14.7602 10.6947L12.4639 14.1391L7.87134 14.1391"
          stroke="currentColor"
          strokeWidth={1.4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  {
    displayName: 'ExternalMonitorsIcon',
    defaultSize: 24,
    defaultVariant: 'primary',
    classNameBase: '',
  },
);
